// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Images/bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Login.module.css */

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.Login_page__C438r {
  display: flex;
  min-height: 100vh;
  font-family: inherit;
}

/* ══════════════════════════════════════
   LEFT PANEL
══════════════════════════════════════ */
.Login_left__ACI-r {
  flex: 1 1;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 40px 48px 28px;
  overflow: hidden;
}

.Login_leftBg__oG\\+T0 {
  position: absolute;
  inset: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
}

.Login_leftOverlay__C2Qa4 {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(15, 35, 60, 0.88) 0%, rgba(10, 55, 80, 0.82) 100%);
}

/* Everything above the overlay */
.Login_leftTop__TPpFv,
.Login_leftMid__PzAz9,
.Login_leftBottom__4hveu {
  position: relative;
  z-index: 1;
}

/* Logo */
.Login_logo__6JrNT {
  display: flex;
  align-items: center;
  gap: 10px;
}

.Login_logo__6JrNT img {
  height: 36px;
  filter: brightness(0) invert(1);
}

/* Badge pill */
.Login_badge__14Uch {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1.5px solid #2db899;
  border-radius: 999px;
  padding: 4px 14px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
  color: #2db899;
  text-transform: uppercase;
  margin-bottom: 20px;
}

.Login_badge__14Uch::before {
  content: "●";
  font-size: 8px;
}

/* Headline */
.Login_headline__az4zK {
  font-size: 2.6rem;
  font-weight: 800;
  color: #ffffff;
  line-height: 1.15;
  margin-bottom: 16px;
}

.Login_headline__az4zK .Login_highlight__SG7Cx {
  color: #2db899;
}

.Login_sub__DFg3E {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.6;
  max-width: 380px;
  margin-bottom: 28px;
}

/* Bullets */
.Login_bullets__jlfsn {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.Login_bullets__jlfsn li {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
  display: flex;
  align-items: center;
  gap: 10px;
}

.Login_bullets__jlfsn li::before {
  content: "●";
  color: #2db899;
  font-size: 9px;
  flex-shrink: 0;
}

/* Stats strip */
.Login_stats__IOZoj {
  background: rgba(255, 255, 255, 0.1);
  -webkit-backdrop-filter: blur(6px);
          backdrop-filter: blur(6px);
  border-radius: 12px;
  padding: 16px 24px;
  display: flex;
  justify-content: space-around;
  margin-bottom: 16px;
}

.Login_statItem__lLLZ6 {
  text-align: center;
}

.Login_statValue__N0gKN {
  display: block;
  font-size: 1.5rem;
  font-weight: 800;
  color: #ffffff;
  line-height: 1;
  margin-bottom: 4px;
}

.Login_statLabel__Dmdyx {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.Login_copyright__2HUQ4 {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.4);
}

/* ══════════════════════════════════════
   RIGHT PANEL
══════════════════════════════════════ */
.Login_right__slyVA {
  width: 50%;
  min-width: 440px;
  background: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 40px;
}

.Login_formBox__ejA2i {
  width: 100%;
  max-width: 420px;
}

/* Botón volver */
.Login_backBtn__-u-Qd {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #667085;
  text-decoration: none;
  border: 1.5px solid #e4e7ec;
  border-radius: 8px;
  padding: 6px 14px;
  margin-bottom: 28px;
  transition:
    border-color 0.2s,
    color 0.2s;
}

.Login_backBtn__-u-Qd:hover {
  border-color: #1a3a5c;
  color: #1a3a5c;
}

/* Logo como link */
.Login_logo__6JrNT {
  text-decoration: none;
}

/* Eyebrow */
.Login_eyebrow__ff\\+gp {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: #2db899;
  margin-bottom: 8px;
}

.Login_formBox__ejA2i h1 {
  font-size: 2rem;
  font-weight: 800;
  color: #1a3a5c;
  line-height: 1.2;
  margin-bottom: 10px;
}

.Login_formDesc__kbrJ\\+ {
  font-size: 14px;
  color: #667085;
  margin-bottom: 28px;
}

/* Fields */
.Login_field__BW-uf {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-bottom: 14px;
}

.Login_fieldHeader__Gw9kq {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.Login_label__ag7J4 {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: #667085;
}

.Login_input__xEN53 {
  height: 44px;
  padding: 0 14px;
  border: 1.5px solid #d0d5dd;
  border-radius: 8px;
  font-size: 14px;
  color: #344054;
  background: #fff;
  outline: none;
  width: 100%;
  transition: border-color 0.2s;
  font-family: inherit;
}

.Login_input__xEN53:focus {
  border-color: #1a3a5c;
}

.Login_input__xEN53::placeholder {
  color: #b0b8c4;
}

.Login_forgotLink__pssGU {
  font-size: 12px;
  color: #667085;
  text-decoration: none;
}

.Login_forgotLink__pssGU:hover {
  color: #2db899;
  text-decoration: underline;
}

/* Password */
.Login_passwordWrap__xahTZ {
  position: relative;
}

.Login_passwordWrap__xahTZ .Login_input__xEN53 {
  padding-right: 42px;
}

.Login_eyeBtn__K4I5p {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: #98a2b3;
  padding: 0;
  display: flex;
  align-items: center;
}

/* Remember checkbox */
.Login_checkRow__0TMx3 {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #344054;
  margin-bottom: 22px;
  cursor: pointer;
}

.Login_checkRow__0TMx3 input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #2db899;
  cursor: pointer;
  flex-shrink: 0;
}

/* Error */
.Login_errorMsg__51diu {
  background: #fff1f0;
  border: 1px solid #fda29b;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 13px;
  color: #d92d20;
  margin-bottom: 16px;
}

/* Botón ingresar */
.Login_btnSubmit__CbSrv {
  width: 100%;
  height: 46px;
  background: #1a3a5c;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 1px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background-color 0.2s;
  margin-bottom: 20px;
}

.Login_btnSubmit__CbSrv:hover {
  background: #1e4a78;
}

.Login_btnSubmit__CbSrv:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Divider */
.Login_divider__roWTm {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  font-size: 13px;
  color: #98a2b3;
}

.Login_divider__roWTm::before,
.Login_divider__roWTm::after {
  content: "";
  flex: 1 1;
  height: 1px;
  background: #e4e7ec;
}

/* Social buttons */
.Login_socialBtn__X2C4f {
  width: 100%;
  height: 44px;
  background: #fff;
  border: 1.5px solid #d0d5dd;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #344054;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition:
    border-color 0.2s,
    background-color 0.2s;
  margin-bottom: 6px;
}

.Login_socialBtn__X2C4f:hover {
  border-color: #98a2b3;
  background: #f8fafc;
}

.Login_socialBtn__X2C4f svg {
  flex-shrink: 0;
}

/* Registro */
.Login_registerRow__-7uaF {
  text-align: center;
  font-size: 14px;
  color: #667085;
  margin-top: 20px;
}

.Login_registerRow__-7uaF a {
  color: #1a3a5c;
  font-weight: 700;
  text-decoration: none;
}

.Login_registerRow__-7uaF a:hover {
  text-decoration: underline;
}

/* ── Responsive ── */
@media (max-width: 900px) {
  .Login_left__ACI-r {
    display: none;
  }
  .Login_right__slyVA {
    width: 100%;
    min-width: unset;
  }
}

@media (max-width: 480px) {
  .Login_right__slyVA {
    padding: 32px 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Login/Login.module.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;wCAEwC;AACxC;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,yDAAmD;EACnD,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2FAA2F;AAC7F;;AAEA,iCAAiC;AACjC;;;EAGE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,+BAA+B;AACjC;;AAEA,eAAe;AACf;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,cAAc;EACd,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,oCAAoC;EACpC,kCAA0B;UAA1B,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;;wCAEwC;AACxC;EACE,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB;;cAEY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,aAAa;AACb;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,WAAW;EACX,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT;;yBAEuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* Login.module.css */\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n.page {\n  display: flex;\n  min-height: 100vh;\n  font-family: inherit;\n}\n\n/* ══════════════════════════════════════\n   LEFT PANEL\n══════════════════════════════════════ */\n.left {\n  flex: 1;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 40px 48px 28px;\n  overflow: hidden;\n}\n\n.leftBg {\n  position: absolute;\n  inset: 0;\n  background-image: url(\"../../assets/Images/bg.jpg\");\n  background-size: cover;\n  background-position: center;\n}\n\n.leftOverlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(135deg, rgba(15, 35, 60, 0.88) 0%, rgba(10, 55, 80, 0.82) 100%);\n}\n\n/* Everything above the overlay */\n.leftTop,\n.leftMid,\n.leftBottom {\n  position: relative;\n  z-index: 1;\n}\n\n/* Logo */\n.logo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.logo img {\n  height: 36px;\n  filter: brightness(0) invert(1);\n}\n\n/* Badge pill */\n.badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 1.5px solid #2db899;\n  border-radius: 999px;\n  padding: 4px 14px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  color: #2db899;\n  text-transform: uppercase;\n  margin-bottom: 20px;\n}\n\n.badge::before {\n  content: \"●\";\n  font-size: 8px;\n}\n\n/* Headline */\n.headline {\n  font-size: 2.6rem;\n  font-weight: 800;\n  color: #ffffff;\n  line-height: 1.15;\n  margin-bottom: 16px;\n}\n\n.headline .highlight {\n  color: #2db899;\n}\n\n.sub {\n  font-size: 15px;\n  color: rgba(255, 255, 255, 0.75);\n  line-height: 1.6;\n  max-width: 380px;\n  margin-bottom: 28px;\n}\n\n/* Bullets */\n.bullets {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.bullets li {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.85);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.bullets li::before {\n  content: \"●\";\n  color: #2db899;\n  font-size: 9px;\n  flex-shrink: 0;\n}\n\n/* Stats strip */\n.stats {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(6px);\n  border-radius: 12px;\n  padding: 16px 24px;\n  display: flex;\n  justify-content: space-around;\n  margin-bottom: 16px;\n}\n\n.statItem {\n  text-align: center;\n}\n\n.statValue {\n  display: block;\n  font-size: 1.5rem;\n  font-weight: 800;\n  color: #ffffff;\n  line-height: 1;\n  margin-bottom: 4px;\n}\n\n.statLabel {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.6);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.copyright {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.4);\n}\n\n/* ══════════════════════════════════════\n   RIGHT PANEL\n══════════════════════════════════════ */\n.right {\n  width: 50%;\n  min-width: 440px;\n  background: #f8fafc;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 40px;\n}\n\n.formBox {\n  width: 100%;\n  max-width: 420px;\n}\n\n/* Botón volver */\n.backBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #667085;\n  text-decoration: none;\n  border: 1.5px solid #e4e7ec;\n  border-radius: 8px;\n  padding: 6px 14px;\n  margin-bottom: 28px;\n  transition:\n    border-color 0.2s,\n    color 0.2s;\n}\n\n.backBtn:hover {\n  border-color: #1a3a5c;\n  color: #1a3a5c;\n}\n\n/* Logo como link */\n.logo {\n  text-decoration: none;\n}\n\n/* Eyebrow */\n.eyebrow {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  color: #2db899;\n  margin-bottom: 8px;\n}\n\n.formBox h1 {\n  font-size: 2rem;\n  font-weight: 800;\n  color: #1a3a5c;\n  line-height: 1.2;\n  margin-bottom: 10px;\n}\n\n.formDesc {\n  font-size: 14px;\n  color: #667085;\n  margin-bottom: 28px;\n}\n\n/* Fields */\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  margin-bottom: 14px;\n}\n\n.fieldHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.8px;\n  text-transform: uppercase;\n  color: #667085;\n}\n\n.input {\n  height: 44px;\n  padding: 0 14px;\n  border: 1.5px solid #d0d5dd;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #344054;\n  background: #fff;\n  outline: none;\n  width: 100%;\n  transition: border-color 0.2s;\n  font-family: inherit;\n}\n\n.input:focus {\n  border-color: #1a3a5c;\n}\n\n.input::placeholder {\n  color: #b0b8c4;\n}\n\n.forgotLink {\n  font-size: 12px;\n  color: #667085;\n  text-decoration: none;\n}\n\n.forgotLink:hover {\n  color: #2db899;\n  text-decoration: underline;\n}\n\n/* Password */\n.passwordWrap {\n  position: relative;\n}\n\n.passwordWrap .input {\n  padding-right: 42px;\n}\n\n.eyeBtn {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #98a2b3;\n  padding: 0;\n  display: flex;\n  align-items: center;\n}\n\n/* Remember checkbox */\n.checkRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: #344054;\n  margin-bottom: 22px;\n  cursor: pointer;\n}\n\n.checkRow input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: #2db899;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n/* Error */\n.errorMsg {\n  background: #fff1f0;\n  border: 1px solid #fda29b;\n  border-radius: 8px;\n  padding: 10px 14px;\n  font-size: 13px;\n  color: #d92d20;\n  margin-bottom: 16px;\n}\n\n/* Botón ingresar */\n.btnSubmit {\n  width: 100%;\n  height: 46px;\n  background: #1a3a5c;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  transition: background-color 0.2s;\n  margin-bottom: 20px;\n}\n\n.btnSubmit:hover {\n  background: #1e4a78;\n}\n\n.btnSubmit:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n/* Divider */\n.divider {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n  font-size: 13px;\n  color: #98a2b3;\n}\n\n.divider::before,\n.divider::after {\n  content: \"\";\n  flex: 1;\n  height: 1px;\n  background: #e4e7ec;\n}\n\n/* Social buttons */\n.socialBtn {\n  width: 100%;\n  height: 44px;\n  background: #fff;\n  border: 1.5px solid #d0d5dd;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #344054;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  transition:\n    border-color 0.2s,\n    background-color 0.2s;\n  margin-bottom: 6px;\n}\n\n.socialBtn:hover {\n  border-color: #98a2b3;\n  background: #f8fafc;\n}\n\n.socialBtn svg {\n  flex-shrink: 0;\n}\n\n/* Registro */\n.registerRow {\n  text-align: center;\n  font-size: 14px;\n  color: #667085;\n  margin-top: 20px;\n}\n\n.registerRow a {\n  color: #1a3a5c;\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.registerRow a:hover {\n  text-decoration: underline;\n}\n\n/* ── Responsive ── */\n@media (max-width: 900px) {\n  .left {\n    display: none;\n  }\n  .right {\n    width: 100%;\n    min-width: unset;\n  }\n}\n\n@media (max-width: 480px) {\n  .right {\n    padding: 32px 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `Login_page__C438r`,
	"left": `Login_left__ACI-r`,
	"leftBg": `Login_leftBg__oG+T0`,
	"leftOverlay": `Login_leftOverlay__C2Qa4`,
	"leftTop": `Login_leftTop__TPpFv`,
	"leftMid": `Login_leftMid__PzAz9`,
	"leftBottom": `Login_leftBottom__4hveu`,
	"logo": `Login_logo__6JrNT`,
	"badge": `Login_badge__14Uch`,
	"headline": `Login_headline__az4zK`,
	"highlight": `Login_highlight__SG7Cx`,
	"sub": `Login_sub__DFg3E`,
	"bullets": `Login_bullets__jlfsn`,
	"stats": `Login_stats__IOZoj`,
	"statItem": `Login_statItem__lLLZ6`,
	"statValue": `Login_statValue__N0gKN`,
	"statLabel": `Login_statLabel__Dmdyx`,
	"copyright": `Login_copyright__2HUQ4`,
	"right": `Login_right__slyVA`,
	"formBox": `Login_formBox__ejA2i`,
	"backBtn": `Login_backBtn__-u-Qd`,
	"eyebrow": `Login_eyebrow__ff+gp`,
	"formDesc": `Login_formDesc__kbrJ+`,
	"field": `Login_field__BW-uf`,
	"fieldHeader": `Login_fieldHeader__Gw9kq`,
	"label": `Login_label__ag7J4`,
	"input": `Login_input__xEN53`,
	"forgotLink": `Login_forgotLink__pssGU`,
	"passwordWrap": `Login_passwordWrap__xahTZ`,
	"eyeBtn": `Login_eyeBtn__K4I5p`,
	"checkRow": `Login_checkRow__0TMx3`,
	"errorMsg": `Login_errorMsg__51diu`,
	"btnSubmit": `Login_btnSubmit__CbSrv`,
	"divider": `Login_divider__roWTm`,
	"socialBtn": `Login_socialBtn__X2C4f`,
	"registerRow": `Login_registerRow__-7uaF`
};
export default ___CSS_LOADER_EXPORT___;
